import ProductsStep from './ProductsStep';
import enhance from './ProductsStepContainer';

const config = {
  name: 'products',
  title: 'Select Products',
  component: enhance(ProductsStep),
};

export default config;
